module.exports = __webpack_public_path__ + "static/media/hero-group-2.031244da.png";